module.exports = __webpack_public_path__ + "c7e3b9fba498d80135e205283d1f5641.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-68.svg
// module id = 592
// module chunks = 0